import { useContext, useRef } from 'react'
import styled from 'styled-components'

import { InputContext, Container } from './InputContext'
import type { InputProps } from './Input'

interface TextareaProps extends InputProps {
  $height?: number
}

function Inner({ value, defaultValue, placeholder, $height, onChange, ...props }: TextareaProps) {
  const { handleBlur, handleFocus, handleKeyDown } = useContext(InputContext)
  const textareaRef = useRef<HTMLTextAreaElement | null>(null)

  return (
    <StyledTextarea
      ref={textareaRef}
      defaultValue={defaultValue}
      value={value}
      placeholder={placeholder}
      $height={$height}
      onChange={onChange}
      onFocus={handleFocus}
      onBlur={handleBlur}
      onKeyDown={handleKeyDown}
      {...props}
    />
  )
}

export function Textarea(props: TextareaProps) {
  return (
    <Container>
      <Inner {...props} />
    </Container>
  )
}

const StyledTextarea = styled.textarea<Pick<TextareaProps, '$height'>>`
  ${({ $height }) => (typeof $height !== 'undefined' ? `height: ${$height}px;` : '')}
  resize: none;
`

export type { TextareaProps }
